const SET_TAGS = (state, data) => {
  state.tags = data
}

export default {
  SET_TAGS
}
